export const getTrialDaysLeft = (user) => Number(user?.trialAccess?.daysLeft ?? 0);

export const isTrialAccessExpired = (user) => {
  const trial = user?.trialAccess;
  if (!trial?.applies || trial.isApproved) return false;
  return Boolean(trial.isExpired || getTrialDaysLeft(user) <= 0);
};

export const getTrialStatus = (user) => {
  if (user?.approvedAt || user?.trialAccess?.isApproved) {
    return { label: 'Approved', color: 'success' };
  }
  if (user?.trialAccess?.isExpired || getTrialDaysLeft(user) <= 0) {
    return { label: 'Expired', color: 'error' };
  }
  return { label: 'Trial', color: 'warning' };
};

export const getTrialIndicator = (user) => {
  const trial = user?.trialAccess;
  if (!trial?.applies || trial.isApproved) return null;
  const daysLeft = Number(trial.daysLeft ?? 0);
  return {
    severity: daysLeft <= 0 ? 'error' : daysLeft <= 7 ? 'warning' : 'info',
    message: daysLeft <= 0
      ? 'Your trial access has expired. Please contact support for account approval.'
      : `Your account is on trial. ${daysLeft} day${daysLeft === 1 ? '' : 's'} left before approval is required.`,
  };
};
